import React, { useState } from "react"
import { navigate } from "gatsby"
import { FormikWizard } from "formik-wizard"
import { useToasts } from "react-toast-notifications"
import { PaystackButton } from "react-paystack"
import { sendNotification, notifyUser } from "../../Helpers"
import NewBusinessIcon from "../../../images/business/new-business.svg"
import steps from "./steps"
import BusinessTitleCard from "../BusinessCardTitle"
import BusinessRegistrationWrapper from "./BusinessRegistrationWrapper"
import Summary from "./views/Summary"

const StartApplication = () => {
  const { addToast } = useToasts()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [showSummary, setShowSummary] = useState(false)

  const [businessData, setBusinessData] = useState([])
  const [businessData2, setBusinessData2] = useState([])

  const [config, setConfig] = useState({})

  const getSteps = async () => {
    setLoading(true)
    const step1 = await fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/BusinessName/step1?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
      }
    ).then((response) => response.json())

    const step2 = await fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/BusinessName/step2?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
      }
    ).then((response) => response.json())

    setBusinessData(step1)
    setBusinessData2(step2)

    setLoading(false)
    setShowSummary(true)
  }

  // Submit Data
  const handleSubmit = (values) => {
    getSteps()

    setData({
      account_number:
        typeof window !== `undefined`
          ? localStorage.getItem("nuban_id_24b854967")
          : null,
      firstname: values.other_info.firstname,
      lastname: values.other_info.lastname,
      proprietor_email: values.other_info.proprietor_email,
      proprietor_phone: values.other_info.proprietor_phone,
      proprietor_company: values.additional_documents.proprietor_company,
      company_name: values.additional_documents.company_name,
      company_address: values.additional_documents.company_address,
      company_country: values.additional_documents.company_country,
      company_state: values.additional_documents.company_state,
      company_city: values.additional_documents.company_city,
      rc_number: values.additional_documents.rc_number,
      representative_name: values.additional_documents.representative_name,
      representative_designation:
        values.additional_documents.representative_designation,
      representative_address:
        values.additional_documents.representative_address,
      representative_country:
        values.additional_documents.representative_country,
      representative_state: values.additional_documents.representative_state,
      representative_city: values.additional_documents.representative_city,
      representative_type: values.additional_documents.representative_type,
      representative_number: values.additional_documents.representative_number,
      representative_identity:
        values.additional_documents.representative_identity,
      cac_certificate: values.additional_documents.cac_certificate,
    })
  }

  const createRecord = async (fields) => {
    await fetch(
      `${
        process.env.DIY_BASE_URL
      }/api/order/v1/BusinessName/step3?order-ref=${localStorage.getItem(
        "orderReference"
      )}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Token ${localStorage.getItem("dd_token")}`,
        },
        body: JSON.stringify(fields),
      }
    )
      .then((response) => response.json())
      .then((response) => {
      })
      .catch((error) => {
        console.error(error)
        return []
      })

    sendNotification({
      to: "indy@sparkle.ng",
      cc: "hello@diylaw.ng",
      from: "indy@sparkle.ng",
      subject: `New Business Registration By ${fields.company_name}`,
      templateId: "d-931d7904508c488296cbcaf2cb60b93b",
      dynamicTemplateData: {
        subject: `New Business Registration By ${fields.company_name}`,
        name: `${fields.company_name}`,
        email: fields.proprietor_email,
        service: "Business Registration",
      },
    })
  }

  const onClose = () => {
    console.log("closed")
  }

  const onSuccess = async (reference) => {
    await createRecord({
      proprietor_company: data.proprietor_company,
      company_name: data.company_name,
      company_address: data.company_address,
      company_country: data.company_country,
      company_state: data.company_state,
      company_city: data.company_city,
      rc_number: data.rc_number,
      representative_name: data.representative_name,
      representative_designation: data.representative_designation,
      representative_address: data.representative_address,
      representative_country: data.representative_country,
      representative_state: data.representative_state,
      representative_city: data.representative_city,
      representative_type: data.representative_type,
      representative_number: data.representative_number,
      representative_identity: {
        name: data.representative_identity,
      },
      cac_certificate: {
        name: data.cac_certificate,
      },
      // payment_reference: ref,
    })

    setLoading(true)
    addToast("Application Successful", {
      appearance: "success",
      placement: "top-center",
      autoDismiss: true,
    })

    notifyUser({
      to: data.proprietor_email,
      from: "indy@sparkle.ng",
      subject: `Business Registration At Sparkle`,
      templateId: "d-f70dd4b4ed1a47b794a4ef3b66b5ea5c",
      dynamicTemplateData: {
        subject: `Business Registration At Sparkle`,
        name: data.firstname,
        service: "Business Registration",
      },
    })

    sendNotification({
      to: "indy@sparkle.ng",
      cc: "hello@diylaw.ng",
      from: "indy@sparkle.ng",
      subject: `Payment Verified for ${data.company_name}`,
      templateId: "d-0f2918f7a8024ab7a6a7ab0a0a34dcde",
      dynamicTemplateData: {
        subject: `Payment Verified for ${data.company_name}`,
        name: `${data.company_name}`,
        email: data.proprietor_email,
        service: "Business Registration",
      },
    })

    localStorage.clear()
    setLoading(false)

    setTimeout(function () {
      navigate("/business-support/get-started")
    }, 1000)
  }

  const initPayment = async () => {
    var min = 10000000000000
    var max = 99999999999999

    var payoutRef = Math.round(Math.random() * (max - min) + min).toString()

    let payload = {
      reference: payoutRef,
      email: data.proprietor_email,
      amount: 2000000,
      metadata: {
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "Business Registration",
          },
        ],
      },
      text: "Pay with Card",
      publicKey: process.env.PAYSTACK_KEY,
    }

     setConfig({ ...config, ...payload })
    document.querySelector("button.paystack").click()
  }
  const componentProps ={
    email:  data.proprietor_email,
    amount: 2000000,
    metadata: {
        custom_fields: [
          {
            display_name: "Business Support Service",
            variable_name: "Business Support Service",
            value: "Business Registration",
          },
        ],
      },
       text:"Pay with Card",
       publicKey: process.env.PAYSTACK_KEY,
       onSuccess : (reference) => onSuccess(reference),
       onClose: onClose
  }


  return (
    <div>
      <div className={!showSummary ? "container" : "container d-none"}>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <BusinessTitleCard
              icon={NewBusinessIcon}
              title='Register New Business'
              subtitle="Officially register your business, get CAC and a tax identification number."
            />

            <div className="business-suport-card my-lg-5 waitlist__form ">
              <FormikWizard
                steps={steps}
                onSubmit={handleSubmit}
                render={BusinessRegistrationWrapper}
              />
            </div>
          </div>
        </div>
      </div>

      <PaystackButton {...componentProps} className="btn paystack d-none" />

      {showSummary && (
        <Summary
          businessData={businessData}
          businessData2={businessData2}
          payFee={initPayment}
          setShowSummary={setShowSummary}
          loadingStatus={loading}
        />
      )}
    </div>
  )
}

export default StartApplication
